import Vue from "vue";
import Owner from "@/model/cospirit-api/Owner";
import AllocationTypeRepository from "@/repositories/budget/AllocationTypeRepository";

export interface AllocationType {
    label: string;
    owner: Owner;
    uuid: string;
}

export default {
    state: {
        allocationTypes: [],
    },
    mutations: {
        setAllocationTypes: (state: any, allocationTypes: AllocationType[]) => {
          Vue.set(state, "allocationTypes", allocationTypes);
        },
    },
    getters: {
        getAllocationTypes: (state: any): AllocationType[] => {
            return state.allocationTypes;
        },
    },
    actions: {
        loadAllocationTypes: ({ commit }: any) => {
          AllocationTypeRepository.get().then((data: any) => {
            commit("setAllocationTypes", data);
          });
        },
    },
};
